module.exports = __webpack_public_path__ + "img/top-restaurant.50e4186.jpg";